import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_tree_node_expand_true",
  "use": "lc_tree_node_expand_true-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" class=\"design-iconfont\" id=\"lc_tree_node_expand_true\">\r\n  <path fill=\"#CCC\" transform=\"rotate(-180 4.0005375 4)\" d=\"M4 1L8 7 0 7z\" fill-rule=\"evenodd\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol